import getRepoDocuments from './getRepoDocuments';

export const hasDocuments = () =>
  getRepoDocuments({ page: 1, perPage: 1 }).then((res) => {
    return res.paging.totalCount > 0;
  });

export default hasDocuments;
